<template v-if="isLoaded">
  <p class="mb-4">Dina förändringar sparas automatiskt.</p>
  <form class="grid gap-4" @submit.prevent="onSubmit">
    <InputText
      keyId="0"
      :placeholder="item.label"
      label="Rubrik för radiogrupp"
      :model="item.label"
      type="text"
      @change="onLabelChange"
      class="col-span-full"
    ></InputText>
    <div
      class="w-full grid grid-cols-12 gap-2"
      v-for="(radioButton, index) in withoutGroup"
      :key="radioButton.item?.key"
    >
      <label
        class="block uppercase tracking-wide text-darkGray-1 text-xs font-bold col-span-full"
        :for="radioButton.item?.key"
        >Radioknapp {{ index + 1 }}</label
      >
      <input
        v-model="radioButton.label"
        @change="
          (e) => {
            onRadioLabelChange(e, radioButton.item.key);
          }
        "
        type="text"
        :id="radioButton.item?.key"
        :label="`radioknapp ${index + 1}`"
        placeholder="Ange texten för radioknappen"
        class="col-span-11 appearance-none block bg-blue-4 text-darkGray-1 placeholder-darkGray-4 border border-blue-4 rounded py-3 px-4 leading-tight focus:bg-white focus:border-blue-1 disabled:bg-gray-2 disabled:text-darkGray-2 disabled:cursor-not-allowed"
      />
      <i
        @click="removeRadio(radioButton)"
        title="Ta bort"
        class="col-span-1 fas fa-trash-alt text-red-2 hover:text-red-2 text-2xl cursor-pointer"
      ></i>
    </div>
  </form>
  <button
    @click="addNewRadio"
    class="mt-4 col-span-full flex gap-2 items-center text-blue-1 hover:text-blue-2 cursor-pointer"
  >
    <i class="fas fa-plus"></i>
    <span>Lägg till radioknapp</span>
  </button>
  <div class="text-darkGray-1 mt-4 mb-1 flex items-center gap-2 col-span-full">
    <label class="text-darkGray-1 mb-1 flex items-center gap-2">
      <input type="checkbox" v-model="isRequired" @change="onRequiredChange" />
      Obligatorisk
    </label>
  </div>

  <div class="flex col-span-full gap-4 mt-4">
    <RegularButton
      @click="$emit('removeField', item)"
      style-type="cancel"
      text="Ta bort gruppen"
    />
    <RegularButton
      @click="
        () => {
          emit('back');
        }
      "
      text="Tillbaka"
    />
  </div>
</template>
<script setup lang="ts">
import {
  defineEmits,
  defineProps,
  ref,
  reactive,
  onMounted,
  computed,
  watch,
} from "vue";
import InputText from "@/features/shared/components/form/InputText.vue";
import * as dtos from "@/models/dtos";
import "v-calendar/dist/style.css";
import { DynamicProperty, RadioItem } from "@/models/dtos";
import RegularButton from "@/features/shared/components/ui/RegularButton.vue";

const emit = defineEmits<{
  (event: "add", key: string, item: DynamicProperty): void;
  (event: "remove", key: dtos.DynamicProperty): void;
  (event: "labelChange", e: any): void;
  (event: "back"): void;
  (event: "removeField", item: DynamicProperty): void;
  (event: "changeRadioLabel", key: string, newLabel: string): void;
  (event: "toggleRadioRequired", isRequired: boolean): void;
}>();

const radioButtons = reactive(new Array<RadioItem>());

const withoutGroup = computed(() =>
  radioButtons.filter((px) => px.item.type !== "radioGroup")
);

const props = defineProps({
  model: {
    type: dtos.DynamicProperty,
    required: true,
  },
  metadata: {
    type: dtos.MetaData,
    required: true,
  },
});
const isLoaded = ref(false);
const item = ref(props.model as dtos.DynamicProperty);
const isRequired = ref(false);

onMounted(() => {
  let properties = props.metadata.properties.filter((x) =>
    props.model.data.keys.includes(x.key)
  );
  properties.forEach((x) => {
    radioButtons.push(new RadioItem(x, x.label));
  });

  isRequired.value = item.value.validators?.find(
    (validator) => validator.name === "radioRequired"
  )?.data;
  isLoaded.value = true;
});

const onRequiredChange = () => {
  emit("toggleRadioRequired", isRequired.value);
};

const addNewRadio = () => {
  const newRadio = new dtos.DynamicProperty();

  newRadio.placeholder = "";
  newRadio.type = "radio";
  newRadio.key = crypto.randomUUID();
  newRadio.label = "";
  newRadio.data = false;
  radioButtons.push(new RadioItem(newRadio));

  emit("add", props.model.key, newRadio);
};

function onLabelChange(event: any) {
  emit("labelChange", event);
}

const removeRadio = (radio: RadioItem) => {
  const index = radioButtons.indexOf(radio);
  radioButtons.splice(index, 1);

  emit("remove", radio.item);
};
function onRadioLabelChange(event: any, key: string) {
  emit("changeRadioLabel", key, event.target.value);
}
</script>
